import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import Button from "@mui/material/Button";
import { getSSOUrl } from '../components/Session';

export default function LoginPage() {
  const [username, setUsername] = useState("");

  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [redirectURL, setRedirectURL] = useState(null)

  const handleLogin = () => {
    console.log("Logging in")
    setIsLoading(true)
    setError(null)

    getSSOUrl(username)
      .then((result) => {
        setRedirectURL(result)
      }
      ).catch((error) => {
        setSuccess(false)
        setError(error.message)
        setIsLoading(false)
      }
      )
  };

  if (redirectURL) {
    console.log("Redirecting to idp", redirectURL)
    window.location.assign(redirectURL)
    // router.push(redirectURL)
  }

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      handleLogin()
    }
  }

  return (
        <Paper>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '25vh' }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <h1>Login</h1>

              {error ? <b>{error}</b> : null}


            </Grid>
            <Grid item xs={12} md={12} lg={12}>

              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <TextField id="input-with-icon-grid" style={{"width": "300px"}} onKeyDown={handleEnter} label="E-Mail" onChange={(e) => setUsername(e.target.value)} value={username} disabled={isLoading} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <br />
              <div className="buttonWrapper">
                <Button
                  onClick={handleLogin}
                  color="primary"
                  variant="contained"
                  disabled={isLoading}
                  className={success ? "buttonSuccess" : ""}
                  type={"submit"}
                >
                  Login
                </Button>
                {isLoading && (
                  <CircularProgress size={24} className="buttonProgress" />
                )}
              </div>
            </Grid>
          </Grid>
        </Paper>
    )
}
